import(/* webpackMode: "eager" */ "/home/runner/work/whoplays-web/whoplays-web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/analytics/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/providers.tsx");
